
import { Button } from '@coingate/ui/dist/components/Button';


export const MethodStep = ({
  onContinueWithGoogleClick,
  onContinueWithEmailClick,
}: {
  onContinueWithGoogleClick: () => void;
  onContinueWithEmailClick: () => void;
}) => {
  return (
    <div className="flex flex-col gap-6">
      <div className="font-normal text-base text-gray-600">
        Start accepting crypto payments today.
      </div>

      <div className="flex flex-col gap-3">
        <Button
          data-testid="continue-with-google"
          className="w-full text-base font-semibold text-white"
          size="lg"
          variant="primary"
          onClick={onContinueWithGoogleClick}
        >
          <img src="/google-fill.svg" />
          Continue with Google
        </Button>

        <Button
          data-testid="continue-with-email"
          className="w-full text-base font-semibold text-grey-600"
          size="lg"
          variant="outlined"
          onClick={onContinueWithEmailClick}
        >
          Continue with email
        </Button>
      </div>
    </div>
  )
}

export default MethodStep
